var React = require('react');

function AddressBook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.4 21.8a1 1 0 0 0 1.4-.2 6.5 6.5 0 0 1 10.4 0 1 1 0 1 0 1.6-1.2 8.49 8.49 0 0 0-3.43-2.71 5 5 0 1 0-6.74 0 8.49 8.49 0 0 0-3.43 2.71 1 1 0 0 0 .2 1.4ZM14 14a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM26 3H8a2 2 0 0 0-2 2v3H4a1 1 0 0 0 0 2h2v5H4a1 1 0 0 0 0 2h2v5H4a1 1 0 0 0 0 2h2v3a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm0 24H8V5h18v22Z"}));
}

AddressBook.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = AddressBook;

AddressBook.default = AddressBook;
